<template>
  <a-form-model ref="noteForm" :model="form">
    <a-form-model-item label="Note">
      <a-textarea v-model="form.catatan" :rows="2"></a-textarea>
    </a-form-model-item>
    <a-form-model-item label="Vice President Finance">
      <a-input
        disabled
        :default-value="
          mode == 'Create'
            ? getApproval.nama_direktur
            : dataProcessed.approval.nama
        "
      />
    </a-form-model-item>
  </a-form-model>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "approval",
  props: ["dataProcessed", "mode", "type"],
  data() {
    return {
      form: {
        catatan: "",
      },
    };
  },
  computed: {
    ...mapGetters(["getAuth", "getApproval"]),
  },
  mounted() {
    this.form.catatan = this.dataProcessed.catatan;
  },
  methods: {
    handleRef() {
      Event.$emit("dataProcessed", this.form.catatan);
    },
  },
};
</script>

<style></style>
